export const NA = 'N/A'
